(function ($) {

   $(window).on('load',function () {
        if($('.js_latest_news_about, .three-card-slider').length>0) {
            setTimeout(function () {
                $(".three-card-slider .row-wrap").css({"opacity":"1"});
            },500);
        }

                $('.three-card-slider .row-wrap').slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                dots: false,
                arrows: true,
                infinite: false,
                cssEase: 'linear',
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 1,
                            draggable: true
                        }
                    }
                ]
            });
    });
       $(window).on('orientationchange',function () {
        setTimeout(function () {
            $('.three-card-slider .row-wrap').slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                dots: false,
                arrows: true,
                infinite: false,
                cssEase: 'linear',
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 1,
                            draggable: true
                        }
                    }
                ]
            });
        },300);

    });

})(jQuery);